// extracted by mini-css-extract-plugin
export default {"wrapper":"Highlights_wrapper__3T4vA","highlight":"Highlights_highlight__aCVEi","progress":"Highlights_progress__x6FF8"};